import { DatePipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';
import { EMPTY } from 'core/utils';
import { BellNotificationModel } from 'models/bell-notifications';
import { AppState, sidebarActions } from 'store';
import { LuxonPipe } from '../../pipes/luxon.pipe';

@Component({
    selector: 'app-notification-card',
    templateUrl: './notification-card.component.html',
    styleUrls: ['./notification-card.component.scss'],
    imports: [MatTooltip, MatIcon, DatePipe, TranslateModule, LuxonPipe],
})
export class NotificationCardComponent {
    private readonly router = inject(Router);
    private readonly store = inject<Store<AppState>>(Store);

    @Input() notification: BellNotificationModel;

    public onNotificationClick() {
        if (this.notification?.url) {
            this.router
                .navigateByUrl(this.notification.url)
                .then(() => {
                    this.store.dispatch(sidebarActions.closeSidebar());
                })
                .catch(EMPTY);
        }
    }
}
